import { createSelector } from '@reduxjs/toolkit';

import { projectSelector } from 'src/selectors/project';

export const projectFileUploadSelector = (
  projectId: string,
  fileUploadId: string | undefined
) =>
  createSelector(
    projectSelector(projectId),
    (project) =>
      (fileUploadId && project?.fileUploadsById[fileUploadId]) || null
  );
